import type { WidgetType } from "@csbi/contracts"
import { SERIES_SLOTS } from "./palette.js"

export type SeriesPresentation = {
  legend: boolean
  directLabels: "required" | "recommended" | "none"
  colorCarriesIdentity: boolean
  mustChangeForm: boolean
  note?: string
}

export function presentationFor(seriesCount: number): SeriesPresentation {
  if (seriesCount <= 1)
    return { legend: false, directLabels: "recommended", colorCarriesIdentity: true, mustChangeForm: false }

  if (seriesCount <= 3)
    return { legend: true, directLabels: "required", colorCarriesIdentity: true, mustChangeForm: false }

  if (seriesCount === 4)
    return {
      legend: true,
      directLabels: "required",
      colorCarriesIdentity: true,
      mustChangeForm: false,
      note: "Slot 4 puts yellow next to orange, so direct labels are required. Map is unavailable.",
    }

  if (seriesCount <= 6)
    return { legend: true, directLabels: "recommended", colorCarriesIdentity: true, mustChangeForm: false }

  if (seriesCount <= SERIES_SLOTS)
    return {
      legend: true,
      directLabels: "recommended",
      colorCarriesIdentity: true,
      mustChangeForm: false,
      note: "Consider small multiples.",
    }

  return {
    legend: false,
    directLabels: "none",
    colorCarriesIdentity: false,
    mustChangeForm: true,
    note: `Past ${SERIES_SLOTS} series colour cannot carry identity — use small multiples or a table.`,
  }
}

const MAP_MAX_SERIES = 3

export function formAllowed(widget: WidgetType, seriesCount: number): boolean {
  if (widget === "map") return seriesCount <= MAP_MAX_SERIES
  if (widget === "stat-tile" || widget === "gauge") return seriesCount <= 1
  if (widget === "table") return true
  return seriesCount <= SERIES_SLOTS
}

export function isSingleHueForm(widget: WidgetType, splitByTenant: boolean): boolean {
  return (widget === "hbar" || widget === "histogram") && !splitByTenant
}
